import React, { Component } from 'react';
import { findIndex, isEqual, cloneDeep } from "lodash"

export class TaskTracker extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount(){
        //Set first task to focused
        //this.props.focusFirstTask()
    }
    getSnapshotBeforeUpdate(prevProps, prevState) {

      if(!isEqual(prevProps.focusedTaskObj, this.props.focusedTaskObj)){

        // Only save state if we are progressing forwards
        if(prevProps.focusedTask < this.props.focusedTask || prevProps.focusedPage < this.props.focusedPage || (this.props.focusedTask === 0 && this.props.focusedPage === 0)){
          //For Undo function - save state as snapshot
          //This next line excludes the Undo reducer state
          //from state saved as a snapshot
          let {undo, ...tempState} = this.props.state.notebook.protocolSection;

          console.log("tempState - saving as snap:", tempState);

          this.props.saveSnapshot({
              snapshot: cloneDeep(tempState)
          })
        }
      }

      return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot){}

    static getDerivedStateFromProps(props, state){

        //Don't run if nothing in last actions
        if(Object.keys(props.lastActions).length === 0){
            return null
        }

        //run checker here, pass anything needed from props
        if(!props.focusedTaskObj.hasOwnProperty('criteria') || props.focusedTaskObj.criteria === undefined){
            //If state hasn't properly loaded yet
            return null
        }

        //Getting all criteria for current task
        const actions = props.focusedTaskObj.criteria.actions
        const crits = props.focusedTaskObj.criteria.critPaths
        const last = props.lastActions
        //let rootObj = props
        //Points to track criteria completed in multi-crit tasks
        let points = props.points

        //First check any actions were fired
        let actionCheck = true
        actions.some(action => {
            //Check if any appear in lstActions

            console.log([last, action])
            if(last.hasOwnProperty(action)){
                actionCheck = true
               //breaks if finds some match
               return true
            } else {
                return false
            }
        })

        //If crit actions are not in last actions, break
        if (!actionCheck) {
            props.clearLastActions()
            return null
        }

        //console.log(actions)
        console.log({"Crits": crits})
        //CHECKS HAPPEN HERE
        crits.forEach((crit, i)=>{
            let rootObj = props
            crit = crit.split("/");

            crit.forEach((step, j)=>{
    
                try {
                    //Check if step is "conditions"
                    if (step === "conditions") {
                        step = crit[j+1]
                        //Found last condition step
                        let conditions = []
                        let and_conditions = []
                        let or_conditions = []

                        //Check if step has &
                        if (step.includes("&")) {
                            //Multiple crit check in this path
                            and_conditions = step.split("&")
                        } else if (step.includes("||")) {
                            //Multiple crit check in this path
                            //alert('found ||')
                            or_conditions = step.split("||")
                            //alert(JSON.stringify(or_conditions))
                        } else {
                            //Only 1 crit check
                            conditions.push(step)
                        }

                        //Now check all conditions in array
                        let passed = true
                        let or_passed = false
                        let temp
                        let temp2
                        let temp3

                        conditions.forEach(con => {

                            if(con.includes(">=")){
                                temp = con.split(">=")
                            } else if (con.includes("<=")){
                                temp = con.split("<=")
                            } else if (con.includes(">")){
                                temp = con.split(">")
                            } else if (con.includes("<")){
                                temp = con.split("<")
                            } else {
                                temp = con.split("=")
                            }

                            if (!isNaN(+temp[1])){
                                temp[1] = +temp[1]
                            } else if (temp[1]==="true"){
                                temp[1] = true
                            } else if (temp[1]==="false"){
                                temp[1] = false
                            }

                            //check for operators
                            if(con.includes(">=")){
                                //console.log(">= found");
                                if (!(rootObj[temp[0]] >= temp[1])) {
                                    passed = false
                                }
                            } else if (con.includes("<=")){
                                //console.log("<= found");
                                if (!(rootObj[temp[0]] <= temp[1])) {
                                    passed = false
                                }
                            } else if (con.includes(">")){
                                //console.log("> found");
                                if (!(rootObj[temp[0]] > temp[1])) {
                                    passed = false
                                }
                            } else if (con.includes("<")){
                                //console.log("< found");
                                if (!(rootObj[temp[0]] < temp[1])) {
                                    passed = false
                                }
                            } else if (con.includes("!=")){
                                //console.log("!= found");
                                //console.log([rootObj[temp[0]] !== temp[1]])
                                if (!(rootObj[temp[0]] !== temp[1])) {
                                    passed = false
                                }
                            } else if (con.includes("{") && con.includes("}")) {
                            //console.log("{} found");
                            //console.log(rootObj, temp[0], temp[1]);
                            if (!isEqual(rootObj[temp[0]], JSON.parse(temp[1]))) {
                                passed = false;
                            }
                            //console.log(rootObj, temp[0], temp[1]);
                            } else if (con.includes("=")) {
                            //console.log("=== found");

                            //console.log(rootObj, temp[0], temp[1]);
                            //console.log(rootObj[temp[0]], temp[1]);


                            if (rootObj[temp[0]] !== temp[1]) {
                                passed = false
                            }
                            }
                        });
                        and_conditions.forEach(con => {

                            if(con.includes(">=")){
                                temp2 = con.split(">=")
                            } else if (con.includes("<=")){
                                temp2 = con.split("<=")
                            } else if (con.includes(">")){
                                temp2 = con.split(">")
                            } else if (con.includes("<")){
                                temp2 = con.split("<")
                            } else {
                                temp2 = con.split("=")
                            }

                            if (!isNaN(+temp2[1])){
                                temp2[1] = +temp2[1]
                            } else if (temp2[1]==="true"){
                                temp2[1] = true
                            } else if (temp2[1]==="false"){
                                temp2[1] = false
                            }

                            //check for operators
                            if(con.includes(">=")){
                                //console.log(">= found");
                                if (!(rootObj[temp2[0]] >= temp2[1])) {
                                    passed = false
                                }
                            } else if (con.includes("<=")){
                                //console.log("<= found");
                                if (!(rootObj[temp2[0]] <= temp2[1])) {
                                    passed = false
                                }
                            } else if (con.includes(">")){
                                //console.log("> found");
                                if (!(rootObj[temp2[0]] > temp2[1])) {
                                    passed = false
                                }
                            } else if (con.includes("<")){
                                //console.log("< found");
                                if (!(rootObj[temp2[0]] < temp2[1])) {
                                    passed = false
                                }
                            } else if (con.includes("!=")){
                                //console.log("!= found");
                                //console.log([rootObj[temp2[0]] !== temp2[1]])
                                if (!(rootObj[temp2[0]] !== temp2[1])) {
                                    passed = false
                                }
                            } else if (con.includes("{") && con.includes("}")) {
                            //console.log("{} found");
                            //console.log(rootObj, temp2[0], temp2[1]);
                            if (!isEqual(rootObj[temp2[0]], JSON.parse(temp2[1]))) {
                                passed = false;
                            }
                            console.log(rootObj, temp2[0], temp2[1]);
                            } else if (con.includes("=")) {
                            //console.log("=== found");
                            if (rootObj[temp2[0]] !== temp2[1]) {
                                passed = false
                            }
                            }
                        });
                        or_conditions.forEach(con => {

                            if(con.includes(">=")){
                                temp3 = con.split(">=")
                            } else if (con.includes("<=")){
                                temp3 = con.split("<=")
                            } else if (con.includes(">")){
                                temp3 = con.split(">")
                            } else if (con.includes("<")){
                                temp3 = con.split("<")
                            } else {
                                temp3 = con.split("=")
                            }

                            if (!isNaN(+temp3[1])){
                                temp3[1] = +temp3[1]
                            } else if (temp3[1]==="true"){
                                temp3[1] = true
                            } else if (temp3[1]==="false"){
                                temp3[1] = false
                            }

                            //alert(con)

                            //check for operators
                            if(con.includes(">=")){
                                //console.log(">= found");
                                if ((rootObj[temp3[0]] >= temp3[1])) {
                                    //alert('or_passed: >=')
                                    or_passed = true
                                }
                            } else if (con.includes("<=")){
                                //console.log("<= found");
                                if ((rootObj[temp3[0]] <= temp3[1])) {
                                    //alert('or_passed: <=')
                                    or_passed = true
                                }
                            } else if (con.includes(">")){
                                //console.log("> found");
                                if ((rootObj[temp3[0]] > temp3[1])) {
                                    or_passed = true
                                }
                            } else if (con.includes("<")){
                                //console.log("< found");
                                if ((rootObj[temp3[0]] < temp3[1])) {
                                    //alert('or_passed: <')
                                    or_passed = true
                                }
                            } else if (con.includes("!=")){
                                //console.log("!= found");
                                //console.log([rootObj[temp3[0]] !== temp3[1]])
                                if ((rootObj[temp3[0]] !== temp3[1])) {
                                    //alert('or_passed: !=')
                                    or_passed = true
                                }
                            } else if (con.includes("{") && con.includes("}")) {
                            //console.log("{} found");
                            //console.log(rootObj, temp3[0], temp3[1]);
                            if (isEqual(rootObj[temp3[0]], JSON.parse(temp3[1]))) {
                                //alert('or_passed: {}')
                                or_passed = true;
                            }
                            console.log(rootObj, temp3[0], temp3[1]);
                            } else if (con.includes("=")) {
                            //console.log("=== found");

                            //console.log(rootObj, temp3[0], temp3[1]);
                            // console.log(rootObj[temp3[0]], temp3[1]);

                            if (rootObj[temp3[0]] === temp3[1]) {
                                //alert('or_passed: =')
                                //alert('or_passed: '+ rootObj[temp3[0]] + ' ' + temp3[1])
                                or_passed = true
                            }
                            }

                        });

                        console.log(passed, conditions.length, and_conditions.length)
                        console.log(or_passed, or_conditions.length)
                        if (
                        ((
                            conditions.length > 0 ||
                            and_conditions.length > 0
                        ) && passed) ||
                        (or_conditions.length > 0 && or_passed)
                        //passed || or_passed
                        ) {
                            //props.incTempPoints()
                            points++

                            console.log("Points: "+points)
                            console.log("Crit: "+crits[i])
                            console.log("Crits: "+crits.length)

                            //Check if all criteria for task are done
                            if(points>=crits.length){
                                props.setTaskCompleted({
                                    pageIndex: props.focusedPage,
                                    taskIndex: props.focusedTask
                                })
                                props.clearTempPoints()
                            }

                            //clearing last actions for new task
                            props.clearLastActions()
                        }
                        return
                    }
                    //Check if step has ==
                    //Do array search
                    else if (step.includes("==")) {
                        const temp = step.split("==")
                        let tempObj = {}

                        if (!isNaN(+temp[1])){
                            temp[1] = +temp[1]
                        } else if (temp[1]==="true"){
                            temp[1] = true
                        } else if (temp[1]==="false"){
                            temp[1] = false
                        }

                        tempObj[temp[0]] = temp[1]
                        console.log({"rootObj": rootObj})
                        console.log({"tempObj": tempObj})
                        rootObj = rootObj[findIndex(rootObj, tempObj)]

                        console.log({"newRootObj": rootObj})
                        return
                    }
                    //If not options above -> std dir step
                    else {

                        if(rootObj.hasOwnProperty(step)){
                        rootObj = rootObj[step]
                        console.log({"step in": rootObj});
                        }

                        return
                    }
                } catch (e) {
                    console.log("Task check failed...");
                    console.log(e);
                    return null
                }
            })
        })

        return null
    }

    render() {
        return (
            <>
            </>
        );
    }
}
